import _ from 'lodash'
import Backbone from 'backbone'
import i18n from 'scoreboard/components/i18n'
import template from './filter-detail.hbs'
import FormView from 'scoreboard/components/form-view'
import OrFilterView from 'scoreboard/reports/common/filter/or-filter'

//Container view for filters, handles the common header/footer portions with
//the main body implemented by a subview that must be passed in to this view
var Filter = Backbone.View.extend({

	tagName: 'form',

	className: 'report-filters',

	/**
	 * The container for holding the view that defines a Report Filter
	 *
	 * @constructs
	 *
	 * @param {Object} options
	 * @param {Object} options.view The constructor of the view for the filter being edited
	 * @param {Object} options.data the filter being edited
	 * @param {String} options.filterKey the key associated with the filter being edited
	 * @param {Object} options.filters the report filter object containing all filters being displayed
	 * @param {String} options.nameCode The message code to use for the header
	 * @param {String} options.dialogType The dialog type for css
	 */
	initialize: function (options = {}) {
		this.options = options
		if (!options || !options.view) {
			throw new Error('Must define view for filter')
		}
		this.data = this.options.data || {}
		let viewOpts = _.assign(_.omit(options, 'view'), _.cloneDeep(options.formOptions || {}), {data: this.data})
		this.view = new options.view(viewOpts)

		var TheFormView = this.view.formViewType || FormView
		this.formView = new TheFormView({
			el: this.el,
			allowCleanSubmission: true,
			submit: this.submit.bind(this)
		})

		//add or group validation
		this.formView.test = _.wrap(this.formView.test, test => {
			if (_.isNil(this.orFilterView.filter.linkGroup)) {
				return i18n.get('datasets.orGroup.required')
			}
			// if the view defines a test function, check that first
			let viewTest = this.view.test
			if (viewTest) {
				let err = viewTest.apply(this.view)
				if (!_.isNil(err)) {
					return err
				}
			}
			return test.apply(this.view)
		})

		//if the view triggers it's own change, pass that along
		this.listenTo(this.view, 'change', this.formView.change.bind(this.formView))
	},


	submit: function (e) {
		//lazy evaulation of filter, we gather values in view and apply them
		//to the model only at the end of the view's life
		let data = _.result(this.view, 'gather')
		data.linkGroup = this.orFilterView.filter.linkGroup
		this.trigger('done', data)
	},

	render: function () {
		this.$el.html(template({
			nameCode: this.options.nameCode,
			dialogType: this.options.dialogType
		}))
		//must add view after setting $el so we can listen to any backbone
		//events triggered by the view to react
		this.$('.filter-detail-content').html(this.view.el)
		this.view.render()

		// If the view we just inserted is a multi-tree-selector, we're going to
		// need to setup its twoColumnsDetailsForm now that the view is in the DOM
		if (_.isFunction(this.view.setupTwoColumnDetailsForm)) {
			this.view.setupTwoColumnDetailsForm()
		}

		//setup the "OR"ing of filters
		this.orFilterView && this.orFilterView.remove()
		this.orFilterView = new OrFilterView(_.defaults({
			filter: this.data,
			meta: this.filterMeta
		}, this.options))
		this.$('.or-filter-content').html(this.orFilterView.el)
		this.orFilterView.render()

		//wire the changes from the or filter
		this.listenTo(this.orFilterView, 'toggle change', this.formView.change.bind(this.formView))

		//if we're in a wizard, render the progress before starting the form so that the primary
		//button is properly shown
		if (this.options.wizard) {
			this.options.wizard.render({el: this. el})
		}

		this.formView.start()
		return this
	},

	resize: function () {
		this.view.resize && this.view.resize()
	},

	remove: function () {
		Backbone.View.prototype.remove.apply(this, arguments)
		_.invokeMap([this.view, this.formView, this.orFilterView], 'remove')
	}

})

export default Filter

Filter.__filename__ = 'reports/wizard/common/filter-detail.js'
